// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1jiDf","buttons":"SendReceipts_buttons__1BGfc","email":"SendReceipts_email__1_VKD","bookApptTitle":"SendReceipts_bookApptTitle__1f0IF"};